import React from 'react';
import classnames from 'classnames';
import styles from './LoaderSettings.module.scss';

interface LoaderFragmentProps {
  id: String;
}

const Bar: React.FC<LoaderFragmentProps> = ({ id }) => {
  return (
    <div
      className={classnames(styles.bar, {
        [styles[`${id}`]]: id,
      })}
    />
  );
};
const BreadcrumbBlock = () => {
  return <Bar id="breadcrumbBlock" />
}
const HeadingBlock = () => {
  return <Bar id="headingBlock" />;
};
const NavBlock = () => {
  return (
    <div className={styles.navBlock}>
      <Bar id="navBlockItem" />
      <Bar id="navBlockItem" />
    </div>
  )
};

export const LoaderSettings = () => {
  return (
    <div className={styles.container}>
      <BreadcrumbBlock />
      <HeadingBlock />
      <NavBlock />
    </div>
  );
};
